export default __webpack_public_path__ + "static/media/1438.e3f1f3b6.png";